import * as sdk from '../sdk';
import { browserHistory } from 'react-router';

export const clearPrivacyPolicy = () => {
  return {
    type: 'CLEAR_PRIVACY_POLICY'
  }
}

export const storePrivacyPolicy = (payload) => {
  return {
    type: 'STORE_PRIVACY_POLICY',
    payload
  }
}

export const getPrivacyPolicy = () => {
  return (dispatch, getState) => {
    return sdk.getPrivacyPolicy(getState().auth.jwToken)
      .then(response => {
        dispatch(storePrivacyPolicy(response.data.data));
      });
  }
}



// WEBPACK FOOTER //
// ./src/actions/privacyPolicyActions.js